export default __webpack_public_path__ + "static/media/Camerron-3.4ff8263d.png";